import { TailSpin } from 'react-loader-spinner';
import {
  BUTTON_VARIANT,
  IButtonProps,
} from 'types/components/button/button.interface';
import './Button.scss';
import { ButtonIcon, ButtonText } from './modules';

const Button = ({
  isLoading,
  children,
  variant = BUTTON_VARIANT.default,
  isActive,
  fullWidth,
  onlyIcon,
  outsideChildren,
  style,
  buttonStyle,
  isClear,
  className,
  wrapperClassNames,
  size = 'default',
  type = 'button',
  ...props
}: IButtonProps) => {
  const baseClasses = 'button';
  const variantClasses = ` ${BUTTON_VARIANT[variant]}`;
  const activeClasses = `${isActive ? ' active' : ''}`;
  const onlyIconClasses = `${onlyIcon ? ' only-icon' : ''}`;
  const fullwidthClasses = fullWidth ? ' full-width' : '';
  const loadingClasses = isLoading ? ' loading' : '';
  const clearClasses = isClear ? ' clear' : '';

  return (
    <div
      className={`button-wrapper${fullwidthClasses}${loadingClasses} ${wrapperClassNames}`}
      style={style}>
      <TailSpin wrapperClass='button-spinner' />
      <button
        style={buttonStyle}
        type={type}
        {...props}
        onClick={e => !isLoading && props.onClick && props.onClick(e)}
        className={`${baseClasses}${variantClasses}${activeClasses}${onlyIconClasses}${clearClasses} ${size} ${className}`}>
        {children}
      </button>
      {outsideChildren}
    </div>
  );
};

Button.Icon = ButtonIcon;
Button.Text = ButtonText;

export default Button;
